import React from "react";
import { motion } from "framer-motion";

const FadeIn = ({
  children,
  delay = 0,
  y = 16,
  duration = 0.4,
  once = true,
  as = "div",
  disableOnScroll = false,
  ...rest
}) => {
  const MotionElement = motion[as] || motion.div;

  if (disableOnScroll) {
    return (
      <MotionElement
        initial={{ opacity: 0, y }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration, ease: "easeOut", delay }}
        {...rest}
      >
        {children}
      </MotionElement>
    );
  }
  return (
    <MotionElement
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration, ease: "easeOut", delay }}
      {...rest}
    >
      {children}
    </MotionElement>
  );
};

export default FadeIn;
